import { render, staticRenderFns } from "./_PlayerForm.vue?vue&type=template&id=02424e0e&scoped=true&"
import script from "./_PlayerForm.vue?vue&type=script&lang=ts&"
export * from "./_PlayerForm.vue?vue&type=script&lang=ts&"
import style0 from "./_PlayerForm.vue?vue&type=style&index=0&id=02424e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02424e0e",
  null
  
)

export default component.exports